import {
  StackProps as MantineStackProps,
  Stack as MantineStack,
} from '@mantine/core';

export type StackProps = MantineStackProps;

export const Stack = MantineStack;

Stack.displayName = 'Stack';
